import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocPortal, MapLocKeys } from '@cm/core/localization';

export type CPBenefitsCatalogLocs =
	| 'CPBenefitsCatalogLabelStatus'
	| 'CPBenefitsCatalogLabelName'
	| 'CPBenefitsCatalogLabelType'
	| 'CPBenefitsCatalogLabelExpireDate'
	| 'CPBenefitsCatalogLabelGroup'
	| 'CPBenefitsCatalogLabelToken'
	| 'CPBenefitsCatalogTitlePage'
	| 'CPBenefitsCatalogContentPageDescription'
	| 'CPBenefitsCatalogContentInvalidToken'
	| 'CPBenefitsCatalogLabelUrl'
	| 'CPBenefitsCatalogContentPreview'
	| 'CPBenefitsCatalogButtonViewMore';

export const cpBenefitsCatalogLocs: LocDefs<CPBenefitsCatalogLocs> = {
	CPBenefitsCatalogLabelStatus: {
		defaultValue: 'Status',
		description: 'Label for status',
		displayPath: 'Benefits|Program|Field Label|Status',
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.FieldLabel.Status',
		portal: 'CP' as LocPortal,
	},
	CPBenefitsCatalogLabelName: {
		defaultValue: 'Name',
		description: 'Label for name',
		displayPath: 'Benefits|Program|Field Label|Name',
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.FieldLabel.Name',
		portal: 'CP' as LocPortal,
	},
	CPBenefitsCatalogLabelType: {
		defaultValue: 'Type',
		description: 'Label for type',
		displayPath: 'Benefits|Program|Field Label|Type',
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.FieldLabel.Type',
		portal: 'CP' as LocPortal,
	},
	CPBenefitsCatalogLabelExpireDate: {
		defaultValue: 'Expire Date',
		description: 'Label for expire date',
		displayPath: 'Benefits|Program|Field Label|ExpireDate',
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.FieldLabel.ExpireDate',
		portal: 'CP' as LocPortal,
	},
	CPBenefitsCatalogLabelGroup: {
		defaultValue: 'Group',
		description: 'Label for group',
		displayPath: 'Benefits|Program|Field Label|Group',
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.FieldLabel.Group',
		portal: 'CP' as LocPortal,
	},
	CPBenefitsCatalogLabelUrl: {
		defaultValue: 'Url',
		description: 'Label for url',
		displayPath: 'Benefits|Program|Field Label|Url',
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.FieldLabel.Url',
		portal: 'CP' as LocPortal,
	},
	CPBenefitsCatalogLabelToken: {
		defaultValue: 'Token',
		description: 'Label for token',
		displayPath: 'Benefits|Program|Field Label|Token',
		displayType: 'Label',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.FieldLabel.Token',
		portal: 'CP' as LocPortal,
	},
	CPBenefitsCatalogTitlePage: {
		defaultValue: 'Benefits',
		description: 'Title for benefits page',
		displayPath: 'Benefits|Program|Title|Benefits',
		displayType: 'Title',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.Title.Benefits',
		portal: 'CP' as LocPortal,
	},
	CPBenefitsCatalogContentPageDescription: {
		defaultValue: '',
		description: 'Page description for benefits page',
		displayPath: 'Benefits|Program|Title|Page Description',
		displayType: 'Content',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.Content.PageDescription',
		portal: 'CP' as LocPortal,
		htmlAllowed: true,
	},
	CPBenefitsCatalogContentInvalidToken: {
		defaultValue: 'Token is no longer valid',
		description: 'Content for invalid token',
		displayPath: 'Benefits|Program|Content|Invalid Token',
		displayType: 'Content',
		feature: HubFeature.Benefit,
		legacyName: 'CPBenefitDetailLocs',
		portal: 'CP' as LocPortal,
	},
	CPBenefitsCatalogContentPreview: {
		defaultValue: 'Preview',
		description: 'Content for preview link',
		displayPath: 'Benefits|Program|Content|Url Preview',
		displayType: 'Content',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.Content.UrlPreview',
		portal: 'CP' as LocPortal,
	},
	CPBenefitsCatalogButtonViewMore: {
		defaultValue: 'View More',
		description: 'Button for view more',
		displayPath: 'Benefits|Program|Button|View More',
		displayType: 'Button',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.Button.ViewMore',
		portal: 'CP' as LocPortal,
	},
};

export const LOC_KEYS = MapLocKeys<CPBenefitsCatalogLocs>(cpBenefitsCatalogLocs);
